import { render, staticRenderFns } from "./AddPlannerShift.vue?vue&type=template&id=145cbc0c"
import script from "./AddPlannerShift.vue?vue&type=script&lang=js"
export * from "./AddPlannerShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports